// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animations-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.animations-section .animations-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.animations-section .animations-wrap .animations-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.animations-section .animations-wrap .animations-box .animation-wrap {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin: 4rem 0;
}
.animations-section .animations-wrap .animations-box .animation-wrap img {
  width: 100%;
  max-width: 100%;
  height: auto;
}
.animations-section .animations-wrap .animations-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
@media screen and (max-width: 991.98px) {
  .animations-section {
    padding: 2.5rem 0;
  }
  .animations-section .animations-wrap .animations-box .para-text {
    font-size: 1rem;
  }
  .animations-section .animations-wrap .animations-box .animation-wrap {
    margin: 2.5rem 0;
  }
  .animations-section .animations-wrap .animations-box .btn-box {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .animations-section {
    padding: 2rem 0;
  }
  .animations-section .animations-wrap .animations-box .para-text {
    font-size: 0.875rem;
  }
  .animations-section .animations-wrap .animations-box .animation-wrap {
    margin: 1.25rem 0;
  }
  .animations-section .animations-wrap .animations-box .btn-box {
    margin-top: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AnimationsSection/AnimationsStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAGM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;AADR;AAGQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;AADV;AAKM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAHR;AAQE;EAtCF;IAuCI,iBAAA;EALF;EASM;IACE,eAAA;EAPR;EAUM;IACE,gBAAA;EARR;EAWM;IACE,kBAAA;EATR;AACF;AAcE;EA1DF;IA2DI,eAAA;EAXF;EAeM;IACE,mBAAA;EAbR;EAgBM;IACE,iBAAA;EAdR;EAiBM;IACE,mBAAA;EAfR;AACF","sourcesContent":[".animations-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .animations-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .animations-box {\n      .para-text {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n      }\n\n      .animation-wrap {\n        display: flex;\n        justify-content: space-between;\n        gap: 1rem;\n        margin: 4rem 0;\n\n        img {\n          width: 100%;\n          max-width: 100%;\n          height: auto;\n        }\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .animations-wrap {  \n      .animations-box {\n        .para-text {\n          font-size: 1rem;\n        }\n  \n        .animation-wrap {\n          margin: 2.5rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .animations-wrap {  \n      .animations-box {\n        .para-text {\n          font-size: 0.875rem;\n        }\n  \n        .animation-wrap {\n          margin: 1.25rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
